import Model from './model.js'

export default class Context {
    constructor(context) {
        this.vars = context.vars
        this.model = new Model(context.model, {locale: context.locale})
        this.locale = context.locale
        this.fields = context.fields
        this.component = context.component
    }

    getVars() {
        return this.vars;
    }

    getVar(v) {
        return this.vars[v];
    }

    getModel() {
        return this.model
    }
}